import {Injectable} from '@angular/core';
import {BehaviorSubject, combineLatest, merge, Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {catchError, filter, finalize, map, shareReplay, switchMap, switchMapTo, tap} from "rxjs/operators";
import {Category, Purchase, Reward} from "@app/feature/reward/models/Reward";
import {Credentials, CredentialsService} from "@core/authentication/credentials.service";
import {plainToInstance} from 'class-transformer';
import {FlashMessageService} from "@shared/partials/flash-message/flash-message.service";
import {UiLoaderService} from "@app/feature/ui/ui-loader/ui-loader.service";


@Injectable({
  providedIn: 'root'
})
export class RewardService {
  constructor(
    public client: HttpClient,
    private credentialsService: CredentialsService,
    private flashMessageService: FlashMessageService,
    private uiLoaderService: UiLoaderService
  ) {

    // Get list of all available rewards
    this.reward$ = this.client.get<Reward[]>(`/reward/`).pipe(
      filter((r)=>r!==undefined),
      map((reward:Reward[])=>plainToInstance(Reward, reward)),
      shareReplay(1)
    )

    // Get list of all available reward categories
    this.rewardCategory$ = this.client.get<Category[]>(`/reward-category/`).pipe(shareReplay(1))

    // All purchases of a specific participant
    this.purchaseRefresh$ = new BehaviorSubject<void>(undefined)

    this.purchase$ = combineLatest([this.purchaseRefresh$, this.credentialsService.change$]).pipe(
        tap(([_, credentials]: [void, Credentials]) => console.log('TAP reward')),
        filter(([_, credentials]: [void, Credentials]) => !!credentials?.participant_id),
        switchMap(([_, credentials]: [void, Credentials])=>
            this.client.get<Purchase[]>(`/participant/${credentials.participant_id}/purchase`)
        ),
        map((reward:Purchase[])=>plainToInstance(Purchase, reward)),
        shareReplay(1)
    )
    // this.purchase$ = this.purchaseRefresh$.pipe(
    //   switchMapTo(this.credentialsService.change$),
    //   filter((credentials: Credentials) => !!credentials?.participant_id),
    //   switchMap((credentials: Credentials)=>
    //     this.client.get<Purchase[]>(`/participant/${credentials.participant_id}/purchase`)
    //   ),
    //   map((reward:Purchase[])=>plainToInstance(Purchase, reward)),
    //   shareReplay(1)
    // )

    this.isPurchaseLoading$ = merge(
        this.purchaseRefresh$.pipe(map(() => true)),
        this.purchase$.pipe(map(() => false)),
    );
  }

  public reward$:Observable<Reward[]>
  public rewardCategory$:Observable<Category[]>
  public purchaseRefresh$:BehaviorSubject<void>
  public purchase$:Observable<Purchase[]>
  public isPurchaseLoading$:Observable<boolean>

  // Purchase a reward
  public purchase(participant_id:number, reward_id:number, send_to:string=undefined){
    this.uiLoaderService.loading$.next({ status: 'open', title: 'Invio richiesta premio', name:'purchaseInProgress'})

    return this.client.post(
      `/participant/${participant_id}/purchase/${reward_id}`,
      send_to ? {send_to} : {}
    )
    .pipe(
      catchError(val =>{ // Show error message
        console.log('catch')
        this.flashMessageService.show('redeemError')
        return of(`${val}`)
      }),
      tap((val)=>{ // Show success message
        console.log('success')
        this.flashMessageService.show('redeemSuccess')
      }),
      finalize(() =>{
        console.log('finalize')
        this.uiLoaderService.loading$.next({status: 'close'})
        this.purchaseRefresh$.next()
      })
    )
  }
}
